__turbopack_context__.v({
  "Two": "collapsiblePanel-module-scss-module__IX6eeW__Two",
  "body": "collapsiblePanel-module-scss-module__IX6eeW__body",
  "chevron": "collapsiblePanel-module-scss-module__IX6eeW__chevron",
  "copy": "collapsiblePanel-module-scss-module__IX6eeW__copy",
  "header": "collapsiblePanel-module-scss-module__IX6eeW__header",
  "inner": "collapsiblePanel-module-scss-module__IX6eeW__inner",
  "limitWidth": "collapsiblePanel-module-scss-module__IX6eeW__limitWidth",
  "main": "collapsiblePanel-module-scss-module__IX6eeW__main",
  "opened": "collapsiblePanel-module-scss-module__IX6eeW__opened",
  "panel": "collapsiblePanel-module-scss-module__IX6eeW__panel",
  "panels": "collapsiblePanel-module-scss-module__IX6eeW__panels",
  "withTop": "collapsiblePanel-module-scss-module__IX6eeW__withTop",
  "withoutTop": "collapsiblePanel-module-scss-module__IX6eeW__withoutTop",
  "wrapper": "collapsiblePanel-module-scss-module__IX6eeW__wrapper",
});
